/* custom script, currently included on product, collection and blog pages
      checks URL for parameters of any kind
      If any dynamic parametes are added to the URL, it places a noindex tag to that URL.
    */

var robotsTag = document.createElement("meta");
var robotsExist;

robotsTag.setAttribute("name", "robots");
robotsTag.setAttribute("content", "noindex, follow");
const paramsFromURL = window.location.search;
// ?page=1 are canonicalized by theme
if (paramsFromURL.toLowerCase().indexOf("?page=1") === -1) {
  if (paramsFromURL == null || paramsFromURL == "") {
    // do nothing
  } else {
    // check if robots tag already exists
    robotsExist = document.querySelector("meta[name='robots']");
    if (robotsExist == null) {
      //append meta tag if there is no meta tag
      document.getElementsByTagName("head")[0].appendChild(robotsTag);
    }
  }
}